import React, { memo } from 'react';

import styles from './index.less';

export const Footer = memo(() => {
  const currentYear = new Date().getFullYear();
  return (
    <div className={styles.tipFooter}>
      {/* <p className={styles.copyright}>粤网文【 2017 】6138-1456号 粤B2-20090059-1</p> */}
      <p className={styles.description}>
        Copyright &copy; 1998 - {currentYear} Tencent. All Rights Reserved. 腾讯公司 版权所有
      </p>
    </div>
  );
});
